// extracted by mini-css-extract-plugin
export default {"banner":"banner--wzIIZ","time":"time--wzIIZ","callUsTitle":"callUsTitle--wzIIZ","trustPilotLine":"trustPilotLine--wzIIZ"};